/**
 * Remove accents and diacritics from a string;
 */
export function removeDiacritics(value: string): string {
  if (!value) {
    return '';
  }

  return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

/**
 * Capitalize a string (first letter in uppercase, rest in lower case).
 */
export function capitalize(value: string): string {
  return value.charAt(0).toUpperCase() + value?.slice(1).toLowerCase();
}

export function fullname(firstname: string | undefined, lastname: string | undefined): string {
  return `${firstname || ''} ${lastname ?? ''}`.trim();
}
